import router from './ai-consultant.router'

export default {
  router,
}
